<template>
    <div class="alert-story-maker">
        <div class="modal">
            <div class="header-modal">
                <p class="title">{{ title }}</p>
                <p class="subTitle">{{ subTitle }}</p>
            </div>
            <div class="choices">
                <p class="choise" :class="{red: choice.warning}" v-for="choice in choices" @click="choice.cb">{{ choice.content }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: ""
            },
            subTitle: {
                type: String,
                default: ""
            },
            choices: {
                type: Array,
                default: () => ([])
            }

        },
    }
</script>

<style lang="scss" scoped>

</style>